/* eslint-disable */
import React, { useEffect, useState, } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import { toastr } from "react-redux-toastr";
import label from "../../labels/accessRightsManagement_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import { getRoleList, saveRoleData, deleteRoleData, editRoleData } from '../../actions/accessRightsManagementActions';
import TablePagination from "../../../common/components/TablePagination";
import { Modal, Button } from 'react-bootstrap';

const DefineRole = () => {

  const { handleSubmit, errors, register, reset } = useForm(
    {
      mode: "onChange",
    }
  );

  const [roleName, setRoleName] = useState("");
  const [roleDescription, setRoleDescription] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [stepName, setName] = useState("AddRole");
  let [listCurrentPage, setListCurrentPage] = useState(0);
  const session = JSON.parse(sessionStorage.getItem("session"));
  // const [roleList,setRoleList]=useState();

  const [show, setShow] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const handleClose = () => setShow(false);

  const editRole = (roleId, updatedRoleData) => {
    dispatch(editRoleData(roleId, updatedRoleData, getRoleList));
  };

  const handleShow = (roleId, roleName, roleDescription) => {
    setSelectedRole({ roleId, roleName, roleDescription });
    setShow(true);
  };

  const deleteRole = () => {
    dispatch(deleteRoleData(selectedRole.roleId, getRoleList, selectedRole.roleName, selectedRole.roleDescription));
    handleClose();
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    if (selectedRole.roleName === '' || selectedRole.roleDescription === '') {
      toastr.error(label.ErrorForRequireFields);
    } else {
      editRole(selectedRole.roleId, { name: selectedRole.roleName, description: selectedRole.roleDescription });
      handleClose();
    }
  };

  const dispatch = useDispatch();

  let rowPerPage = 10;

  useEffect(() => {
    window.scrollTo(0, 0)
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  let { roleList } = useSelector(
    (state) => state?.accessRightsManagementReducer,
    shallowEqual
  );

  useEffect(() => {
    if (stepName == "RoleList") {
      dispatch(getRoleList());
      // setRoleList(getRoleList)
    }
  }, [stepName, listCurrentPage, rowPerPage, dispatch])

  const onCancelButton = () => {
    reset();
    setReloadItem(!reloadItem);
  };

  const onSubmit = (e) => {
    // if (roleName !== '' && roleDescription !== '') {
    //   dispatch(saveRoleData(roleName, roleDescription, setRoleName, setRoleDescription));
    //   onCancelButton();
    // }
    // else {
    //   toastr.error(label.ErrorForRequireFields);
    // }
    if (roleName !== '' || roleDescription !== '') {
      dispatch(saveRoleData(roleName, roleDescription));
    }

    setRoleName("");
    setRoleDescription("");
    onCancelButton();
  };

  const onChangeRoleDescription = (val) => {
    setRoleDescription(val);
  }

  const handleActive = (roleId, isActive) => {
    dispatch(editRoleData(roleId, { isActive: !isActive }, getRoleList));
  };

  return (
    <div className="dashboardContentArea">
      <h5> {label.DefineRole} </h5>
      <div className="tab-content border border-light myTabContent"
        id="myTabContentContainer">
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" key="0">
            <a
              href="#"
              className={
                stepName === "AddRole"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="AddRole"
              id="AddRole-tab"
              onClick={() => setName("AddRole")}
              data-toggle="tab"
              role="tab"
              aria-controls="AddRole"
              aria-selected="false"
            >
              <span>{label.AddRole}</span>
            </a>
          </li>
          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "RoleList"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="RoleList"
              id="unapproved-tab"
              onClick={() => setName("RoleList")}
              data-toggle="tab"
              role="tab"
              aria-controls="RoleList"
              aria-selected="false"
            >
              <span>{label.RoleList}</span>
            </a>
          </li>
        </ul>
        <div className="tab-content border border-light" id="myTabContent">

          <div className={
            stepName === "AddRole"
              ? "tab-pane fade show active"
              : "tab-pane fade styled-tab"
          }
            id="AddRole"
            role="tabpanel"
            aria-labelledby="list-tab">

            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="DefineRoleForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div className="row">
                      <div className="col-md-3">
                        <label className="float-left">
                          {label.RoleName}
                          <span className="errorText">*</span>
                        </label>
                        <input type="text" name="roleName" onChange={(e) => { setRoleName(e.target.value) }} className="form-control" maxLength={25} ref={register({ required: true })} />
                        {errors?.roleName?.type === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 ">
                        <label className="float-left">
                          {label.Description}
                          <span className="errorText">*</span>
                        </label>
                        <textarea
                          name="roleDescription"
                          onChange={(e) => { onChangeRoleDescription(e.target.value); }}
                          className="form-control "
                          ref={register({
                            required: true,
                            pattern: {
                              value: /^(?:(?!\s{2}).)*$/,

                            },
                          })}

                          maxLength={50}
                          rows={2}
                        />
                        {_.get(errors, "roleDescription.type") === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                        {_.get(errors, "roleDescription.type") === "pattern" && (
                          <p className="errorText float-left">
                            {commonLabels.InputInvalid}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-6 ">
                        {(session.roleName === 'superadmin') &&
                          <>
                            <button
                              type="reset"
                              className="btn btn-secondary mr-2 mt-10 ml-10"
                              onClick={() => onCancelButton()}
                            >
                              {commonLabels.BUTTON_CANCEL}
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary   mr-2 mt-10"
                              onClick={handleSubmit((e) => {
                                onSubmit(e);
                              })}
                            // onClick={onSubmit}
                            >
                              {commonLabels.BUTTON_SAVE}
                            </button> </>}

                      </div>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>
          <div className={
            stepName === "RoleList"
              ? "tab-pane fade show active"
              : "tab-pane fade styled-tab"
          }
            id="RoleList"
            role="tabpanel"
            aria-labelledby="RoleList-tab">
            {roleList && roleList.length > 0 ? (
              <>
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      <th className="text-center col-1">{label.Srno}</th>
                      <th className="col-3">{label.RoleName}</th>
                      <th className="col-6">{label.Description}</th>
                      <th className="text-center col-2">{label.Action}</th>
                    </tr>

                  </thead>
                  <tbody>
                    {roleList && roleList.length > 0 && roleList.filter((ele) => ele.isDeleted == false).map((item, index) => {
                      return (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td >{item.name}</td>
                          <td >{item.description}</td>
                          {/* <td className="text-center">
                            <button
                              type="button"
                              className="btn btn-primary fa fa-edit"
                              onClick={() => {
                                handleShow(item.id, item.name, item.description);
                                setIsEditMode(true);
                              }}
                            >

                            </button>
                            <span> </span>
                            <button
                              type="button"
                              className="btn btn-danger fa fa-trash"
                              onClick={() => {
                                handleShow(item.id, item.name, item.description);
                                setIsEditMode(false);
                              }}
                            >

                            </button>
                          </td> */}
                          <td className="col-1 text-center">
                            <i
                              role="button"
                              data-toggle="tooltip"
                              title="Edit"
                              className={"text-primary fa fa-edit fa-lg"}
                              onClick={() => {
                                handleShow(item.id, item.name, item.description);
                                setIsEditMode(true);
                              }}
                            ></i>
                            &nbsp;&nbsp;
                            <i role="button"
                              data-toggle="tooltip"
                              title={item.isActive ? commonLabels.BUTTON_INACTIVE : commonLabels.BUTTON_ACTIVE}
                              className={item.isActive === true ? "text-success fa fa-toggle-on fa-lg" : "text-danger fa fa-toggle-off fa-lg"}
                              onClick={() => { handleActive(item.id, item.isActive); }}>
                            </i>
                            &nbsp;&nbsp;
                            <i
                              role="button"
                              data-toggle="tooltip"
                              title="Delete"
                              className={"text-danger fa fa-trash fa-lg"}
                              onClick={() => {
                                handleShow(item.id, item.name, item.description);
                                setIsEditMode(false);
                              }}
                            ></i>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>

                {/* Modal for delete */}
                {!isEditMode && (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to delete {selectedRole?.roleName}?</Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                        Close
                      </Button>

                      <Button variant="danger" onClick={deleteRole}>
                        Delete
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}
                {/* Modal for edit */}
                {isEditMode && (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Edit Role</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <form>
                        <div className="form-group">
                          <label htmlFor="roleName">
                            Role Name:
                            <span className="errorText">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="roleName"
                            name="role"
                            ref={register({ required: true })}
                            defaultValue={selectedRole && selectedRole.roleName}
                            onChange={(e) =>
                              setSelectedRole({ ...selectedRole, roleName: e.target.value })
                            }
                          />
                          {_.get("role.type", errors) === "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                        </div>
                        <br />
                        <div className="form-group">
                          <label htmlFor="roleDescription">
                            Role Description:
                            <span className="errorText">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="roleDescription"
                            name="roleDes"
                            ref={register({ required: true })}
                            defaultValue={selectedRole && selectedRole.roleDescription}
                            onChange={(e) =>
                              setSelectedRole({ ...selectedRole, roleDescription: e.target.value })
                            }
                          />
                          {_.get("roleDes.type", errors) === "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                        </div>
                        <br />
                      </form>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                        Close
                      </Button>
                      <Button variant="primary" onClick={handleEditSubmit}>
                        Save
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}
                {/* <TablePagination
                  paginationFor="un_verion_mismatch_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  totalCount={getdepartmentList.totalNoOfRecords}
                /> */}
              </>
            ) : (<div className="text-center">
              <font className="text-danger">
                {commonLabels.NO_DATA_FOUND}
              </font>
            </div>)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefineRole;
